import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { BoldPlugin } from '../../slatePlugins/marks/bold/BoldPlugin';
import { HighlightPlugin } from '../../slatePlugins/marks/highlight/HighlightPlugin';
import { ItalicPlugin } from '../../slatePlugins/marks/italic/ItalicPlugin';
import { UnderlinePlugin } from '../../slatePlugins/marks/underline/UnderlinePlugin';
import { colorsV2 } from '../colors-v2';
import { Typography } from '../DesignSystemV2/Typography';
import { DolEditor } from '../DolEditor/DolEditor';
import { ReadOnlyPlugin } from '../DolEditor/handlers/read-only/ReadOnlyPlugin';

const Content = styled.div<{ isExpanded }>`
  font-size: 14px;
  line-height: 20px;
  user-select: none;
  pointer-events: none;
  display: flex;
  align-items: center;

  @media ${deviceBreakpoints.desktop} {
    ${(p) => (p.isExpanded ? 'margin-top: 8px;' : 'margin-left: 16px;')}
  }

  strong {
    font-weight: 700;
  }
`;

const Main = styled.section<{ isExpanded? }>`
  line-height: 24px;
  color: ${colorsV2.black100};
  display: block;
  @media ${deviceBreakpoints.desktop} {
    ${(p) => (p.isExpanded ? 'display: block;' : 'display: flex;')}
  }
`;

export interface QuestionGroupGuidelineProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  // TODO: remove any type
  content?: any;
  isExpanded?: boolean;
}

export const QuestionGroupGuideline = (props: QuestionGroupGuidelineProps) => {
  const { className, title, content, isExpanded = false } = props;

  return (
    <Main className={className} isExpanded={isExpanded}>
      <div className="guideline-header">
        <Typography.Text variant="bold/16">{title}</Typography.Text>
      </div>

      <Content isExpanded={isExpanded}>
        <DolEditor
          initialValue={content}
          plugins={[
            ReadOnlyPlugin(),
            BoldPlugin(),
            ItalicPlugin(),
            UnderlinePlugin(),
            HighlightPlugin(),
          ]}
        />
      </Content>
    </Main>
  );
};
